import React from "react";
import { node, string } from "prop-types";
import Block from "../Block";
import { classes } from "../utils/classes";
import { sxPropTypes, sxProps } from "../props/sx";
import pureProps, { deepMergeProps } from "../utils/pureProps";

const TestimonialBlockQuote = ({ author, company, children, sx = { ...sxProps } }) => (
	<Block className="testimonial__blockquote">
		<Block spacing={{ mb: 4 }} sx={deepMergeProps({ fontSize: "xl" }, pureProps(sx))}>
			{children}
		</Block>
		{author && <Block className={classes("testimonials-author__name")}>{author}</Block>}
		{company && <Block className={classes("testimonials-author__brand")}>{company}</Block>}
	</Block>
);

TestimonialBlockQuote.propTypes = {
	author: string.isRequired,
	company: string.isRequired,
	children: node.isRequired,
	sx: sxPropTypes,
};

export default TestimonialBlockQuote;
